import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { createSelector, StoreModule } from "@ngrx/store";
import { CommodityEffect } from "./effect";
import { CommodityReducer } from "./reducer";

import { contractList } from "app/store/contract-hub/contract/store.module";

@NgModule({
  imports: [EffectsModule.forFeature([CommodityEffect]), StoreModule.forFeature("commodity", CommodityReducer)]
})
export class CommodityStoreModule {}

export const commodityList = (store: any) => store && store.commodity && store.commodity.commodityList;
export const commodityByFieldList = (store: any) => store && store.commodity && store.commodity.commodityByFieldList;
export const commodityById = (store: any) => store && store.commodity && store.commodity.commodityById;
export const addCommodityResp = (store: any) => store && store.commodity && store.commodity.addCommodityResp;
export const updateCommodityResp = (store: any) => store && store.commodity && store.commodity.updateCommodityResp;
export const deleteCommodityResp = (store: any) => store && store.commodity && store.commodity.deleteCommodityResp;
export const commodityLinkedToContractId = (store: any) => store && store.commodity && store.commodity.commodityLinkedToContractId;
export const costTrackerContractsByCommodityId = (store: any) =>
  store && store.commodity && store.commodity.costTrackerContractsByCommodityId;

export const costTrackerContractsList = createSelector(
  contractList,
  costTrackerContractsByCommodityId,
  (allContracts, costTrackerContracts) => {
    if (allContracts && costTrackerContracts) {
      return allContracts.filter(({ id }) => costTrackerContracts.some(({ contractId }) => id === contractId));
    }
    return null;
  }
);
